<template>
  <div id="app">
    <header>
      <h1><router-link to="/">Ivan Rozhkov</router-link></h1>
      
      <!-- Hamburger Icon -->
      <div class="hamburger" @click="toggleMenu">
        <div class="bar" v-if="!isMenuOpen"></div>
        <div class="bar" v-if="!isMenuOpen"></div>
        <div class="bar" v-if="!isMenuOpen"></div>
        <div v-if="isMenuOpen">✖</div>
      </div>

      <!-- Navigation Links -->
      <nav :class="{ open: isMenuOpen }">
        <router-link @click="closeMenu" to="/">Blog</router-link>
        <router-link @click="closeMenu" to="/about">About Me</router-link>
        <router-link @click="closeMenu" to="/experience">Professional Experience</router-link>
        <router-link @click="closeMenu" to="/contact">Contact</router-link>
      </nav>
    </header>

    <router-view />
    <FooterComponent />
  </div>
</template>

<script>
import FooterComponent from './components/Footer.vue';
import { addLogos } from './utils';

export default {
  name: 'App',
  components: {
    FooterComponent
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
  mounted() {
    addLogos();
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    }
  }
};
</script>

<style>
body {
  font-family: 'Montserrat', sans-serif; /* Use Google Fonts */
  color: #333;
  line-height: 1.6;
  margin: 0;
  padding: 0;
  background: #f4f4f4;
}

header {
  position: fixed;
  top: 0;
  background: linear-gradient(135deg, #2c3e50, #34495e);
  color: #fff;
  padding: 0;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  left: 0;
  width: 100%;
  z-index: 1000;
  backdrop-filter: blur(10px);
  background-color: rgba(44, 62, 80, 0.95);
}

header h1 {
  margin: 0;
  padding: 0.75rem 0 0.25rem 0;
  font-size: 1.8rem;
  font-weight: 600;
}

header h1 a {
  color: #fff;
  text-decoration: none;
  transition: opacity 0.3s ease;
  position: relative;
}

header h1 a:hover {
  opacity: 0.8;
  text-decoration: none;
}

header nav {
  padding: 0.25rem 0 0.75rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

header nav a {
  color: #fff;
  margin: 0 0.5rem;
  font-weight: 400;
  padding: 0.4rem 0.9rem;
  text-decoration: none;
  transition: all 0.3s ease;
  border-radius: 25px;
  position: relative;
  font-size: 0.95rem;
}

header nav a:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
  text-decoration: none;
}

header nav a.router-link-exact-active {
  background: rgba(255, 255, 255, 0.15);
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Hamburger Icon Styles */
.hamburger {
  position: absolute;
  top: 50%;
  right: 1.5rem;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1001;
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  width: 2.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  transition: background 0.3s ease;
}

.hamburger:hover {
  background: rgba(255, 255, 255, 0.2);
}

.hamburger .bar {
  width: 1.5rem;
  height: 2px;
  background-color: #fff;
  margin: 3px 0;
  transition: all 0.3s ease;
  border-radius: 2px;
}

.hamburger div {
  color: #fff;
  font-size: 1.5rem;
  font-weight: 300;
}

@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }
}

/* Mobile Navigation Menu */
@media (max-width: 768px) {
  header nav {
    display: none;
    flex-direction: column;
    align-items: center;
    background: rgba(44, 62, 80, 0.98);
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    width: 100%;
    padding: 0;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    z-index: 999;
    transition: all 0.3s ease;
    max-height: 0;
    overflow: hidden;
  }

  header nav.open {
    display: flex;
    max-height: 400px;
    padding: 1rem 0;
  }

  header nav a {
    width: 90%;
    text-align: center;
    margin: 0.25rem 0;
    padding: 0.75rem 1rem;
  }

  header h1 {
    font-size: 1.5rem;
    padding: 0.6rem 0 0.4rem 0;
  }
}



/* Desktop Specific Styles */
@media (min-width: 769px) {
  .hamburger {
    display: none;
  }
}

#app {
  padding-top: 4.5rem;
  padding-bottom: 4rem;
  animation: fadeIn 0.5s ease;
  min-height: 100vh;
  position: relative;
}

@media (max-width: 768px) {
  #app {
    padding-top: 3.5rem;
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

a {
  color: #007acc; /* Blue as accent color */
  transition: all 0.3s ease;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
  opacity: 0.8;
}

.logo-pattern-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1000;
  overflow: hidden;
}

.logo-pattern-background .logo {
  pointer-events: none; 
  position: absolute;
  z-index: -999; 
}

@keyframes fadeInLogo {
  from { opacity: 0; }
  to { opacity: 0.3; }
}

.logo-pattern-background .logo-pattern-background-img {
  opacity: 0.3;  /* Increased opacity since we have much fewer logos */
  max-width: 7.5rem;
  height: auto;
  animation: fadeInLogo 0.5s ease;
  transition: transform 0.2s ease-out;
  filter: grayscale(15%); /* Further reduced grayscale for better visibility */
}

.logo-layer {
  transition: transform 0.1s ease-out;
}

html, body {
  overflow-x: hidden; 
  margin: 0;
  padding: 0;
}

</style>